export interface TrackerStudent {
  readonly id: string
  readonly fullName: string
  readonly imageUrl: string | null
}

export interface TrackerStudentsResponse {
  readonly students: readonly TrackerStudent[]
}

export interface FrameworkItem {
  readonly id: string
  readonly color: string
  readonly name: string
  readonly lv1Name: string
  readonly breadcrumb: string
  readonly originalCodes: string
  readonly assessmentAverage: number | null
}

export interface TrackerResponse {
  readonly frameworkItems: readonly FrameworkItem[]
}

export const ALL_STUDENTS = 'all' as const
export type StudentFilter = string
